export default __webpack_public_path__ + "static/media/banner_w320.60ef975f.jpeg";